import React from "react";
import { CircularProgress } from "@mui/material";
import { useSite } from "hooks/use-site";

type LogoProps = {
  color?: "dark" | "light";
  height?: number;
  src?: string;
  loading?: boolean;
};

const Logo: React.FC<LogoProps> = ({
  src,
  color = "light",
  height = 68,
  loading,
}) => {
  const { logo, isLogoLoading } = useSite();
  const resolvedSrc = src ?? logo;
  const showLoading = loading ?? isLogoLoading;

  if (showLoading && !resolvedSrc) {
    return (
      <CircularProgress
        size={Math.max(height * 0.55, 24)}
        aria-label="Loading logo"
      />
    );
  }

  if (!resolvedSrc) {
    return null;
  }

  return (
    <img
      src={resolvedSrc}
      alt="logo"
      style={{
        display: "block",
        maxHeight: height,
        maxWidth: "100%",
        height: "auto",
        width: "auto",
      }}
    />
  );
};

export default Logo;
